<template>
  <!-- 酒店详情 -->
  <div>
    <el-dialog :title="$t('order.details')" :visible="visible" top="5vh" width="60%" center custom-class="dialog" :before-close="cancelBut" append-to-body>
      <div v-if="details" v-loading="dialogLoading" class="el-dialog-body">
        <h2 class="title">{{ $t('order.information') }}</h2>
        <table class="tab1">
          <tr>
            <th width="200">{{ $t('order.order_sn') }}：</th>
            <td colspan="3" class="text-left">{{ details.order_sn }}</td>
          </tr>
          <tr>
            <th>{{ $t('order.client_type') }}：</th>
            <td colspan="3" class="text-left">{{ details.client_type }}</td>
          </tr>
          <tr>
            <th>{{ $t('order.created') }}：</th>
            <td colspan="3" class="text-left">{{ details.created }}</td>
          </tr>
          <!-- 订单状态 -->
          <tr>
            <th>{{ $t('order.order_status') }}：</th>
            <td colspan="3" class="text-left">
              {{ details.order_status_show }}
              {{ details.order_status == 23 ? '('+details.refuse_desc + ')' : '' }}
            </td>
          </tr>
          <tr>
            <th>{{ $t('order.cancel_desc') }}：</th><!-- 变更政策 -->
            <td colspan="3" class="text-left">{{ details.cancel_desc }}</td>
          </tr>
          <tr>
            <th>{{ $t('order.Stayinstructions') }}：</th><!-- 入住说明checkinstructions -->
            <td colspan="3" class="text-left">
              <el-input v-model="details.remark" :placeholder="$t('order.checkinstructions')" :label="details.remark" :value="details.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" @blur="addstyinremark(details.id)" />
            </td>
          </tr>
          <tr>
            <th>{{ $t('order.special_remark') }}：</th><!-- 特殊需求 -->
            <td colspan="3" class="text-left">{{ details.special_remark ? details.special_remark : "-" }}</td>
          </tr>
          <tr v-if="details.actual_start_time">
            <!-- 到店时间/离店时间(实际) -->
            <th>{{ $t('order.actualTime') }}</th>
            <td colspan="3" class="text-left">
              {{ details.actual_start_time }} /
              {{ details.actual_end_time ? details.actual_end_time : '--' }}
            </td>
          </tr>
          <tr>
            <!-- 操作 -->
            <th>{{ $t('order.operation')+$t('order.order') }}：</th>
            <td colspan="3" class="text-left">
              <!-- 取消 && btnPer.order_cancel -->
              <template v-if="btnPer.order_refund">
                <el-button v-if="details.order_status == 4 || details.order_status == 6 || details.order_status == 41" type="primary" size="mini" icon="el-icon-circle-close" @click="showDialog('offline_cancel')">{{ $t('order.CancelOrder') }}</el-button>
              </template>
              <!-- 审核 -->
              <template v-if="btnPer.alp_offline_checkedOrder">
                <el-button v-if="details.order_status == 6" type="primary" size="mini" icon="el-icon-bell" @click="showDialog('examine')">{{ $t('order.ExamineOrder') }}</el-button>
              </template>
              <!-- 确认到店 -->
              <template v-if="btnPer.alp_offline_confirmStartTime">
                <el-button v-if="details.order_status == 4" type="primary" size="mini" icon="el-icon-check" @click="showDialog('confirmArrival')">{{ $t('order.ConfirmArrival') }}</el-button>
              </template>
              <!-- 离店退房 (已入住状态下显示)-->
              <template v-if="btnPer.alp_offline_check_out">
                <el-button v-if="details.order_status == 5" type="primary" size="mini" icon="el-icon-remove" @click="showDialog('CheckOut')">{{ $t('order.CheckOut') }}</el-button>
              </template>
              <!-- 添加备注 -->
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="showDialog('addremark')">{{ $t('order.addremark') }}</el-button>
              <!-- 打印订单 -->
              <el-button type="primary" size="mini" icon="el-icon-printer" @click="printDetail">{{ $t('print')+$t('order.order') }}</el-button>
              <!-- 打印登记表 -->
              <el-button type="primary" size="mini" icon="el-icon-printer" @click="printRegist">{{ $t('print')+$t('order.registrationForm') }}</el-button>
            </td>
          </tr>
        </table>

        <h2 class="title">{{ $t('order.reservation_information') }}</h2>
        <!-- 酒店 -->
        <table class="tab1">
          <tr style="background-color: #FFFFFF">
            <th>{{ $t('order.hotel.product') }}</th>
            <th>{{ $t('order.hotel.product_model') }}</th>
            <th>{{ $t('order.hotel.start_time') }}</th><!-- 入住日期 -->
            <th>{{ $t('order.hotel.end_time') }}</th><!-- 退房日期 -->
            <th>{{ details.room_type == 3 ? $t('order.hotel.product_num') : $t('order.hotel.tao') }}</th><!-- 间数/套数 -->
            <th>{{ $t('order.product_price') }}</th><!-- 单价 -->
            <th>{{ $t('order.order_amount') }}</th><!-- 订单金额 -->
            <th v-if="details.actual_start_time">{{ $t('order.ConfirmArrival') + $t('table.date') }}</th><!-- 确认到店时间 -->
          </tr>
          <tr>
            <td>{{ details.product }}</td>
            <td>{{ details.product_model }}</td>
            <td>{{ details.start_time }}</td>
            <td>{{ details.end_time }}</td>
            <td>{{ details.product_num }}</td>
            <td>{{ details.pay_fee_type === 'RMB' ? '¥' : 'Rp' }}{{ details.product_price }}</td>
            <td>{{ details.pay_fee_type === 'RMB' ? '¥' : 'Rp' }}{{ details.order_amount }}</td>
            <td v-if="details.actual_start_time">{{ details.actual_start_time }}</td>
          </tr>
        </table>
        <el-row v-if="details.product_info" style="margin-bottom: 10px;">{{ $t('order.hotel.product_info') }}</el-row><!-- 每日价格详情(含税) -->
        <table class="tab1">
          <tr>
            <th v-for="(item, index) in details.product_info" :key="index">{{ item.date }}</th>
          </tr>
          <tr>
            <td v-for="(item, index) in details.product_info" :key="index">{{ details.pay_fee_type === 'RMB' ? '¥' : 'Rp' }}{{ item.price }}</td>
          </tr>
        </table>
        <!-- 客人信息 -->
        <h2 class="title">{{ $t('order.tourist') }}</h2>
        <table v-loading="editTouristloading" class="tab1" :element-loading-text="$t('order.preserving')">
          <tr>
            <!-- 序号 -->
            <th rowspan="2">{{ $t('table.id') }}</th>
            <!-- 入住人 -->
            <th rowspan="2">{{ $t('order.hotel.name') }}</th>
            <!-- 房间号 -->
            <th v-if="btnPer.alp_offline_editTouristRoomNum" rowspan="2">{{ $t('order.RoomNumber') }}</th>
            <!-- 证件号(护照) -->
            <th rowspan="2">{{ $t('order.certificateNum') + '(' + $t('order.id_no') + ')' }}</th>
            <!-- 航班号 -->
            <th colspan="2">{{ $t('order.FLT_No') }}</th>
            <!-- 操作 -->
            <!-- <th rowspan="2">{{ $t('order.operation') }}</th> -->
          </tr>
          <tr>
            <!-- 落地 -->
            <th>{{ $t('order.fall_to_the_ground') }}</th>
            <!-- 返航 -->
            <th>{{ $t('order.course_reversal') }}</th>
          </tr>
          <tr v-for="(item,index) in details.tourist" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <el-input v-model="item.name" :placeholder="$t('order.hotel.name')" size="small" class="inp" />
            </td>
            <td v-if="btnPer.alp_offline_editTouristRoomNum">
              <el-input v-model="item.room_num" :placeholder="$t('order.hotel.room_num')" size="small" class="inp" :disabled="!btnPer.alp_offline_editTouristRoomNum" />
            </td>
            <td>
              <el-input v-model="item.id_no" :placeholder="$t('order.id_no')" size="small" class="inp" />
            </td>
            <td>
              <el-input v-model="item.come_flight_num" :placeholder="$t('order.fall_to_the_ground')" size="small" class="inp" />
            </td>
            <td>
              <el-input v-model="item.back_flight_num" :placeholder="$t('order.course_reversal')" size="small" class="inp" />
            </td>
          </tr>
          <tr>
            <td :colspan="btnPer.alp_offline_editTouristRoomNum ? 6 : 5">
              <el-button type="primary" size="mini" style="padding:7px 40px;" @click="editTourist(details.tourist)">{{ $t('order.save') }}</el-button><!-- 保存 -->
            </td>
          </tr>
        </table>
        <!-- 支付信息 -->
        <h2 class="title">{{ $t('order.payment_information') }}</h2>
        <table class="tab1">
          <tr>
            <th>{{ $t('order.paid') }}</th>
            <th>{{ $t('order.pay_type') }}</th>
            <th>{{ $t('order.pay_order_sn') }}</th>
            <th>{{ $t('order.real_amount') }}</th>
          </tr>
          <tr>
            <td>{{ details.paid }}</td>
            <td>{{ details.pay_type }}</td>
            <td>{{ details.pay_order_sn }}</td>
            <td>{{ details.real_amount }}({{ details.pay_fee_type }})</td>
          </tr>
        </table>
        <!-- 订单日志 -->
        <h2 class="title">{{ $t('order.log.title') }}</h2>
        <table class="tab1">
          <tr>
            <th>{{ $t('order.log.created') }}</th>
            <th>{{ $t('order.log.username') }}</th>
            <th>{{ $t('order.log.action') }}</th>
            <th>{{ $t('order.log.status') }}</th>
            <th>{{ $t('order.remark') }}</th>
          </tr>
          <tr v-for="(item, index) in details.log" :key="index">
            <td>{{ item.created }}</td>
            <td>{{ item.username }}</td>
            <td>{{ item.action }}</td>
            <td>{{ item.status }}</td>
            <td>{{ item.remark }}</td>
          </tr>
        </table>
      </div>
    </el-dialog>
    <!-- 退款原因弹窗 -->
    <uOfflineDialog v-if="reasonVisible" :reason-visible="reasonVisible" :dialog-type="dialogType" @subremark="subremark" @cancelBut="reasonVisible = false" />
  </div>
</template>

<script>
import base from '../../base'
import uOfflineDialog from './offlineDialog'
import {
  offlineDetail // 线下订单详情
} from '@/api/order'
export default {
  components: { uOfflineDialog },
  extends: base,
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderid: {
      type: Number,
      default: null
    },
    btnPer: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      dialogLoading: false,
      details: undefined,
      check_in_remark: null,
      money: undefined,
      dialogVisible: false,
      editTouristloading: false
    }
  },
  created() {
    this.seeDetails()
  },
  methods: {
    /** 查看详情 */
    seeDetails() {
      var data = {
        order_id: this.orderid
      }
      this.dialogLoading = true
      offlineDetail(data).then(res => {
        this.details = { ...res.data }
        this.check_in_remark = this.details.remark
        this.money = res.data.real_amount
        this.dialogLoading = false
      })
      this.dialogVisible = true
    },

    /** 关闭弹窗/取消 */
    cancelBut() {
      this.$emit('cancelBut')
    },

    /** 操作成功后,刷新父页面订单列表 */
    fresh() {
      this.$emit('fresh')
    },
    getList() {}
  }
}
</script>

<style lang="scss">
// .dialog {
// min-width: 960px;
// }
</style>
